import { TextColumns } from 'redux/cacheables/initialState'

export const COLUMN_WIDTHS: Record<'name' | keyof TextColumns, number> = {
  name: 222, // includes quantity and controls menu
  setSymbol: 50,
  price: 50,
  dragHandle: 10,
  colorTag: 22,
  collectionInfo: 10,
  pinnedInfo: 15,
  manaCost: 120,
  extraOptions: 10,
  finishes: 10,
  gamechangers: 20,
  canlanderPoints: 10,

  // Depricated (hopefully)
  type: 200,
  setName: 150,
}
